export default __webpack_public_path__ + "static/media/ao.59445056.svg";